<script setup>
/* eslint-disable @intlify/vue-i18n/no-raw-text, vue/no-bare-strings-in-template */
// Barra de passos do formulário de campanha (decisão 30). Mostra onde a pessoa
// está e o que já ficou para trás. Passo já visitado volta com um clique; passo
// à frente não: só se chega nele pelo Continuar, que valida.
defineProps({
  steps: { type: Array, required: true },
  currentIndex: { type: Number, required: true },
  furthestIndex: { type: Number, default: 0 },
});

const emit = defineEmits(['go']);
</script>

<template>
  <ol
    class="flex flex-wrap items-center gap-1"
    aria-label="Passos da campanha"
    data-testid="campaign-step-bar"
  >
    <li
      v-for="(step, index) in steps"
      :key="step.id"
      class="flex items-center gap-1"
    >
      <button
        type="button"
        class="flex items-center gap-2 px-2.5 py-1.5 text-xs rounded-lg transition-colors"
        :class="[
          index === currentIndex
            ? 'bg-n-alpha-black2 text-n-slate-12 font-semibold'
            : 'text-n-slate-11',
          index <= furthestIndex && index !== currentIndex
            ? 'hover:bg-n-alpha-black2'
            : '',
          index > furthestIndex ? 'cursor-default opacity-60' : '',
        ]"
        :disabled="index > furthestIndex"
        :aria-current="index === currentIndex ? 'step' : undefined"
        :data-step="step.id"
        @click="emit('go', index)"
      >
        <span
          class="inline-flex items-center justify-center rounded-full size-5 text-[10px] font-bold"
          :class="
            index < furthestIndex
              ? 'bg-n-teal-9 text-white'
              : 'bg-n-alpha-black2 text-n-slate-11'
          "
        >
          <span v-if="index < furthestIndex" class="i-ph-check size-3" />
          <template v-else>{{ index + 1 }}</template>
        </span>
        {{ step.title }}
      </button>
      <span
        v-if="index < steps.length - 1"
        class="i-ph-caret-right size-3 text-n-slate-10"
        aria-hidden="true"
      />
    </li>
  </ol>
</template>
